import styled, {css} from 'styled-components'

export const StyledContentWrapper = styled.div`
    ${({theme: {spacing, mediaQueries}}) => css`
        margin: ${spacing * 4}px 0px;
        display: grid;
        gap: ${spacing * 4}px;
        align-items: center;
        width: 100%;

        ${mediaQueries.m} {
            margin: ${spacing * 8}px 0px;
            gap: ${spacing * 8}px;
            width: 360px;
        }
    `}
`

export const StyledButtonWrap = styled.div`
    ${({theme: {mediaQueries}}) => css`
        width: 100%;
        & button {
            margin: 0 auto;
        }

        ${mediaQueries.m} {
            width: 360px;
        }
    `}
`
